import React,{useEffect} from "react";
import "../../styles/description/Presentation.css";
import Location from '../../assets/images/Presentation/placeholder.png';
import Solution from '../../assets/images/Presentation/solutions.png';
import Coding from '../../assets/images/Presentation/coding.png';
import Visible from '../../assets/images/Presentation/visible.png';
import Aos from "aos";
import 'aos/dist/aos.css'
import { useTranslation } from "react-i18next";

export default function Presentation() {
  const {t} = useTranslation();
    const PresentationInfo = [
        {title: "GÉOLOCALISATION & TÉLÉMATIQUES", desc: "Proposer des solutions de suivi des objets connectés par GPS /GPRS en temps réel.", img: Location},
        {title: "CRÉATION DES SITES WEB", desc: "Fournir aux clients des sites aboutis, esthétiques et professionnels.", img: Coding},
        {title: "CRÉATION DES SOLUTIONS", desc: "Transformer les besoins métiers en applications Web et Desktop grâce à son équipe dynamique et expérimentée.", img: Solution},
        {title: "BRANDING", desc: "Créer une identité visuelle originale des entreprises (charte graphique, logo …)", img: Visible}
    ];

    useEffect(()=> {
      Aos.init();
    },[])
  return (
    <section className="Presentation-container-section">
      <h1 className="Title">{t('About.pole')} <span className="SpanHighlightBlue">{t('About.pole-2')}</span></h1>
      <div className="Presentation-container">
      {PresentationInfo.map((p, index) => {
        return (
          <div className="presentation-card" data-aos="fade-up">
            <div className="presentation-image">
              <img src={p.img} alt={p.title} />
            </div>
            <div className="presentation-content">
              <h1>{p.title}</h1>
              <p>{p.desc}</p>
            </div>
          </div>
        );
      })}
    </div>
    </section>
  );
}
